import { useEffect, useRef } from 'react';
import selectors from '@/redux/selectors/selectors';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';

const useExternalUpdate = ({ key = '', callback, dependencies = [] }) => {
  const externalUpdate = useArgSelector(selectors.externalUpdate, key);

  const externalUpdateRef = useRef(externalUpdate || null);

  useEffect(() => {
    if (externalUpdateRef.current === externalUpdate) {
      return;
    }
    externalUpdateRef.current = externalUpdate;
    callback?.();
  }, [externalUpdate, ...dependencies]);

  return externalUpdateRef.current;
};

export default useExternalUpdate;
